import React from 'react';
import { 
  LayoutDashboard, 
  Users, 
  Package, 
  ShoppingCart, 
  BarChart3, 
  Settings,
  ChevronLeft,
  ChevronRight,
  LogOut,
  Shield,
  FolderTree,
  UserCircle,
  Truck
} from 'lucide-react';
import './AdminSidebar.css';

const AdminSidebar = ({ activeTab, setActiveTab, collapsed, setCollapsed, onLogout, isMobile }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'vendors', label: 'Vendors', icon: Users },
    { id: 'products', label: 'Products', icon: Package },
    { id: 'categories', label: 'Categories', icon: FolderTree },
    { id: 'inventory', label: 'Inventory', icon: Package },
    { id: 'pricing', label: 'Pricing', icon: Settings },
    { id: 'kyc', label: 'KYC Review', icon: Shield },
    { id: 'orders', label: 'Orders', icon: ShoppingCart },
    { id: 'deliveries', label: 'Delivery Management', icon: Truck },
    { id: 'customers', label: 'Customers', icon: UserCircle },
    { id: 'reports', label: 'Reports', icon: BarChart3 },
    { id: 'payouts', label: 'Payouts', icon: BarChart3 },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className={`admin-sidebar ${collapsed ? 'collapsed' : 'open'}`}>
      <div className="admin-sidebar-header">
        <div className="admin-logo">
          <div className="admin-logo-icon">
            <Shield size={20} />
          </div>
          {!collapsed && <span className="admin-logo-text">Admin Portal</span>}
        </div>
        <button 
          className="admin-collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      
      <nav className="admin-sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`admin-nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(item.id);
                if (isMobile) {
                  setCollapsed(true);
                }
              }}
            >
              <Icon size={20} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>
      
      <div className="admin-sidebar-footer">
        <button
          className="admin-logout-btn"
          onClick={onLogout}
        >
          <LogOut size={20} />
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
